"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var normalizePathname_1 = __importDefault(require("./normalizePathname"));
var isSubUrlOf = function (url, maybeSubUrl) {
    var cleanUrl = normalizePathname_1.default(url || '');
    var cleanSubUrl = normalizePathname_1.default(maybeSubUrl || '');
    return cleanUrl.indexOf(cleanSubUrl) > -1;
};
exports.default = isSubUrlOf;
